import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminProvider } from "./lib/admin";
import Shop from "./pages/Shop";
import AdminLogin from "./pages/AdminLogin";

function App() {
  return (
    <AdminProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Shop />} />
          <Route path="/admin" element={<AdminLogin />} />
        </Routes>
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </AdminProvider>
  );
}

export default App;
